import { IAppState } from '../../../AppModulesWrapper';

import { ERegions } from '../../constants/regions';

export const selectUserLocationId = (state: IAppState): number => {
  return state.servicePickerWidget.user.geo?.id || ERegions.Moscow;
};
